export const LOCALES = ['el_GR', 'en_IE'];
export const API_URL = '/api/v1/ferries/autocomplete/fallback';
export const GREEK_LANGUAGE_REGEX = /^[\u0370-\u03FF\u1F00-\u1FFF]/;
